var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Divider, InputLabel } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { container } from "../../inversify/inversify.config";
import { TYPES } from "../../inversify/types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import DateFnsUtils from "material-ui-pickers/utils/moment-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/MuiPickersUtilsProvider";
import DatePicker from "material-ui-pickers/DatePicker";
import { ClientUsageReportParams } from "../../helpers/Domain/ViewModels/ClientUsageReportParams";
import Select from "react-select";
import { UsageReportTab } from "./UsageReport";
import { getCurrentYearFirstDay } from "../../common/Validation";
var notification = container.get(TYPES.INotification);
var ReturnDeliveryModes = [
    { value: -1, label: "All" },
    { value: 0, label: "Electronic Delivery" },
    { value: 1, label: "Print to Paper Delivery" },
];
var UsageReportFilter = /** @class */ (function (_super) {
    __extends(UsageReportFilter, _super);
    function UsageReportFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFromDateChange = function (date) {
            _this.setState({ fromDate: moment(date).format("MM/DD/YYYY") });
        };
        _this.handleToDateChange = function (date) {
            _this.setState({ toDate: moment(date).format("MM/DD/YYYY") });
        };
        _this.handleIsHideTest = function (event) {
            _this.setState({ isHideTest: event.target.checked }, function () {
                return _this.props.hideTest(_this.state.isHideTest);
            });
        };
        _this.filter = function () {
            var groupBy = _this.props.selectedCompany
                ? UsageReportTab.User
                : UsageReportTab.Company;
            var companyId = _this.props.selectedCompany
                ? _this.props.selectedCompany.value
                : 0;
            if (_this.validateDate()) {
                _this.props.filter(new ClientUsageReportParams(_this.state.fromDate, _this.state.toDate, _this.props.selectedTaxSoftware.value, groupBy, _this.props.selectedDeliveryMode.value, companyId));
            }
        };
        _this.clearfilter = function () {
            _this.setState({
                fromDate: getCurrentYearFirstDay(),
                toDate: new Date(),
                isHideTest: true,
            }, function () { return _this.props.hideTest(_this.state.isHideTest); });
            _this.props.clearfilter();
        };
        _this.handleDeliveryModeChange = function (selectedValue) {
            _this.setState({ selectedDeliveryMode: selectedValue });
        };
        _this.testAccountFilter = function () {
            return (_jsx("div", __assign({ className: "gtr-checkbox-hide-companies" }, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { name: "hidetestaccount", checked: _this.state.isHideTest, onChange: _this.handleIsHideTest }), className: "user-internal-account-label", label: _jsx("span", __assign({ className: "user-internal-account-label" }, { children: "Hide Internal Use Accounts" })) }) })));
        };
        _this.getUserSelectionFilter = function () {
            return (_jsx(React.Fragment, { children: _jsx(Grid, __assign({ item: true, lg: 2 }, { children: _jsxs("div", __assign({ style: { width: "100%" } }, { children: [_jsx(InputLabel, __assign({ style: { transform: "translate(0, -0.25px) scale(0.75)" } }, { children: "Company" })), _jsx(Select, { value: _this.state.selectedCompany, onChange: function (e) {
                                    return _this.props.handleCompanyChange &&
                                        _this.props.handleCompanyChange(e);
                                }, options: _this.state.companies, searchable: true, className: "clientLedgerDropdownColor" })] })) })) }));
        };
        _this.loadDeliveryModes = function () {
            var _self = _this;
            var arr = [];
            ReturnDeliveryModes.map(function (deliveryMode) {
                var temp = { value: deliveryMode.value, label: deliveryMode.label };
                if (arr.find(function (o) { return o.value === deliveryMode.value; }) == undefined) {
                    arr.push(temp);
                }
            });
            _self.setState({ deliveryModes: arr, selectedDeliveryMode: arr[0] });
        };
        _this.state = {
            fromDate: getCurrentYearFirstDay(),
            toDate: new Date(),
            usageReportExpansionPanel: "usageReportExpansionPanel",
            isHideTest: true,
            groupBy: 0,
            selectedDeliveryMode: { value: -1, label: "All" },
            deliveryModes: [],
            companies: [],
            selectedCompany: {},
        };
        return _this;
    }
    UsageReportFilter.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.companies) {
            this.setState({
                companies: nextProps.companies,
                selectedCompany: nextProps.selectedCompany,
            });
        }
    };
    UsageReportFilter.prototype.componentWillMount = function () {
        this.loadDeliveryModes();
    };
    UsageReportFilter.prototype.validateDate = function () {
        if (Date.parse(this.state.fromDate.toLocaleString("en-us")) >
            Date.parse(this.state.toDate.toLocaleString("en-us"))) {
            notification.warn("From Date cannot be greater than To Date");
            return false;
        }
        return true;
    };
    UsageReportFilter.prototype.toggleClass = function () {
        this.setState({
            usageReportExpansionPanel: this.state.usageReportExpansionPanel == ""
                ? "usageReportExpansionPanel"
                : "",
        });
    };
    UsageReportFilter.prototype.render = function () {
        var _this = this;
        return (_jsx("div", __assign({ className: this.state.usageReportExpansionPanel }, { children: _jsxs(Accordion, __assign({ defaultExpanded: true }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, {}), onClick: function () {
                            _this.toggleClass();
                        } }, { children: _jsx(Typography, __assign({ style: { fontWeight: "bold", fontSize: '0.875rem' } }, { children: "Filter & Export" })) })), _jsx(AccordionDetails, { children: _jsxs(Grid, __assign({ container: true, lg: 12 }, { children: [_jsx(Grid, __assign({ item: true, lg: 3, className: "martop17 clientLedgerDatePicker" }, { children: _jsx(MuiPickersUtilsProvider, __assign({ utils: DateFnsUtils }, { children: _jsx(DatePicker, { name: "fromdate", keyboard: true, label: "From Date", format: "MM/DD/YYYY", placeholder: "MM/DD/YYYY", mask: function (value) {
                                                return value
                                                    ? [
                                                        /\d/,
                                                        /\d/,
                                                        "/",
                                                        /\d/,
                                                        /\d/,
                                                        "/",
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]
                                                    : [];
                                            }, value: this.state.fromDate, onChange: this.handleFromDateChange, animateYearScrolling: false, InputLabelProps: { shrink: true } }) })) })), _jsx(Grid, __assign({ item: true, lg: 3, className: "martop17 clientLedgerDatePicker" }, { children: _jsx(MuiPickersUtilsProvider, __assign({ utils: DateFnsUtils }, { children: _jsx(DatePicker, { name: "todate", keyboard: true, label: "To Date", format: "MM/DD/YYYY", placeholder: "MM/DD/YYYY", mask: function (value) {
                                                return value
                                                    ? [
                                                        /\d/,
                                                        /\d/,
                                                        "/",
                                                        /\d/,
                                                        /\d/,
                                                        "/",
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]
                                                    : [];
                                            }, value: this.state.toDate, onChange: this.handleToDateChange, animateYearScrolling: false, InputLabelProps: { shrink: true } }) })) })), _jsx(Grid, __assign({ item: true, lg: 2 }, { children: _jsxs("div", __assign({ style: { width: "82%" } }, { children: [_jsx(InputLabel, __assign({ style: { transform: "translate(0, -0.25px) scale(0.75)" } }, { children: "TaxSoftware" })), _jsx(Select, { value: this.props.selectedTaxSoftware, onChange: function (e) { return _this.props.handleTaxSoftwareChange(e); }, options: this.props.taxSoftwareList, searchable: true, className: "clientLedgerDropdownColor" })] })) })), _jsx(Grid, __assign({ item: true, lg: 2 }, { children: _jsxs("div", __assign({ style: { width: "83%" } }, { children: [_jsx(InputLabel, __assign({ style: { transform: "translate(0, -0.25px) scale(0.75)" } }, { children: "Delivery Mode" })), _jsx(Select, { value: this.props.selectedDeliveryMode, onChange: function (e) {
                                                    return _this.props.handleDeliveryModeChange(e);
                                                }, options: this.state.deliveryModes, searchable: true, className: "clientLedgerDropdownColor" })] })) })), this.props.groupBy == UsageReportTab.User &&
                                    this.getUserSelectionFilter()] })) }), _jsx(Divider, {}), _jsxs(AccordionActions, __assign({ className: "custom-accordion-actions" }, { children: [this.testAccountFilter(), _jsx(Button, __assign({ variant: "outlined", size: "small", onClick: this.props.downloadasPdf, color: "default", className: "ext-filter-btn" }, { children: "Download" })), _jsx(Button, __assign({ variant: "outlined", size: "small", onClick: this.clearfilter, color: "default", className: "ext-filter-btn" }, { children: "Clear" })), _jsx(Button, __assign({ variant: "outlined", size: "small", onClick: this.filter, color: "primary", className: "ext-filter-btn" }, { children: "Filter" }))] }))] })) })));
    };
    return UsageReportFilter;
}(React.Component));
export { UsageReportFilter };
